import React from 'react';
import DENTConfirmationModal from './DENTConfirmationModal';

interface Props {
	onConfirm: () => void;
	onClose: () => void;
}

const DENTToothDetailCloseConfirmationModal = ({
	onConfirm,
	onClose,
}: Props) => {
	return (
		<DENTConfirmationModal
			title={
				'patientTreatment.meddiDENT.dentalCross.overviewModal.closeConfirmModalTitle'
			}
			text={
				'patientTreatment.meddiDENT.dentalCross.overviewModal.closeConfirmModalText'
			}
			isOpen
			onClose={onClose}
			onConfirm={onConfirm}
		/>
	);
};

export default DENTToothDetailCloseConfirmationModal;
